import { render, staticRenderFns } from "./body.vue?vue&type=template&id=502ab722&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"
import style0 from "./body.vue?vue&type=style&index=0&id=502ab722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ab722",
  null
  
)

export default component.exports